import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Crewmate from "../components/Crewmate";

const UPDATED  = "17 марта 2026 г.";
const OPERATOR = "ИП Кузина Татьяна Николаевна";
const INN      = "401900080185";
const OGRNIP   = "322402700054046";
const EMAIL    = "kuzin.denison@gmail.com";
const SITE     = "neonparty.ru";

const PLANS = [
  { name: "Попробовать", price: "99",  rooms: 3  },
  { name: "Вечеринка",   price: "299", rooms: 15 },
  { name: "Для команды", price: "799", rooms: 50 },
];

const Section = ({ title, children }) => (
  <section style={{ marginBottom: "2rem" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.85rem" }}>
      <div style={{
        background: "#ff3cac", border: "2.5px solid #000",
        borderRadius: "0.5rem", boxShadow: "2px 2px 0 #000",
        width: "0.5rem", height: "1.5rem", flexShrink: 0,
      }} />
      <h2 style={{
        fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem",
        color: "#ff3cac", margin: 0,
      }}>{title}</h2>
    </div>
    <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.95rem", color: "#bbb", lineHeight: 1.8 }}>
      {children}
    </div>
  </section>
);

const Li = ({ children }) => (
  <li style={{ marginBottom: "0.4rem", paddingLeft: "0.25rem", listStyle: "none" }}>
    <span style={{ color: "#ff3cac", marginRight: "0.4rem" }}>▸</span>{children}
  </li>
);

export default function OfferPage() {
  const navigate = useNavigate();
  return (
    <div className="page-root" style={{ minHeight: "100vh", color: "#fff" }}>
      <Navbar />
      <div style={{ maxWidth: "780px", margin: "0 auto", padding: "3rem 1.5rem 5rem" }}>

        {/* Hero */}
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
            <Crewmate color="#ff3cac" size={52} animate="bounce" />
          </div>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.8rem", color: "#444", marginBottom: "0.4rem" }}>
            Последнее обновление: {UPDATED}
          </p>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(1.8rem,5vw,2.75rem)",
            color: "#fff", lineHeight: 1.15,
            textShadow: "4px 4px 0 #ff3cac, 7px 7px 0 #000",
          }}>Публичная оферта</h1>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.88rem", color: "#555", marginTop: "0.5rem" }}>
            Договор на предоставление доступа к PRO функциям сервиса {SITE}
          </p>
        </div>

        {/* Content */}
        <div className="card-cartoon" style={{ padding: "2rem" }}>

          <Section title="1. Общие положения">
            <p>Настоящая публичная оферта (далее — «Оферта») является официальным предложением <strong style={{color:"#fff"}}>{OPERATOR}</strong> (далее — «Исполнитель») заключить договор на предоставление доступа к PRO функциям сервиса {SITE} на условиях, изложенных ниже.</p>
            <br/>
            <p>Оферта адресована физическим и юридическим лицам (далее — «Пользователь»). Акцептом Оферты является совершение оплаты.</p>
            <br/>
            <p>Договор считается заключённым с момента получения Исполнителем подтверждения об оплате.</p>
          </Section>

          <Section title="2. Предмет договора">
            <p>Исполнитель обязуется предоставить Пользователю доступ к PRO играм сервиса {SITE} в виде промокода (кода доступа) на определённое количество игровых сессий.</p>
            <br/>
            <p>Одна игровая сессия = создание одной игровой комнаты в PRO режиме.</p>
          </Section>

          <Section title="3. Стоимость услуг и тарифы">
            <p>Действующие тарифы на дату публикации Оферты:</p>
            <br/>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem" }}>
                <thead>
                  <tr>
                    {["Тариф", "Стоимость", "Игровых сессий"].map(h => (
                      <th key={h} style={{ background: "#ff3cac", color: "#000", border: "2px solid #000", padding: "0.5rem 0.75rem", fontFamily: "'Fredoka One', sans-serif", fontSize: "0.9rem", textAlign: "left" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {PLANS.map((p, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? "#0d0820" : "#110825" }}>
                      <td style={{ border: "2px solid #1a0535", padding: "0.5rem 0.75rem", color: "#fff" }}>{p.name}</td>
                      <td style={{ border: "2px solid #1a0535", padding: "0.5rem 0.75rem", color: "#ffe600", fontWeight: 700 }}>{p.price} ₽</td>
                      <td style={{ border: "2px solid #1a0535", padding: "0.5rem 0.75rem", color: "#ccc" }}>{p.rooms} сессий</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <br/>
            <p>Исполнитель вправе изменять тарифы. Новые тарифы применяются к заказам, поступившим после публикации изменений.</p>
          </Section>

          <Section title="4. Порядок оплаты">
            <ul style={{ padding: 0 }}>
              <Li>Оплата производится безналичным способом через платёжный сервис ЮКасса (банковские карты, СБП, ЮMoney и другие доступные методы).</Li>
              <Li>После успешной оплаты промокод направляется на email, указанный Пользователем при оформлении заказа, а также отображается на странице подтверждения оплаты.</Li>
              <Li>Момент оплаты — дата зачисления денежных средств на счёт Исполнителя.</Li>
            </ul>
          </Section>

          <Section title="5. Права и обязанности сторон">
            <p><strong style={{color:"#fff"}}>Исполнитель обязуется:</strong></p>
            <ul style={{ padding: 0, marginTop: "0.5rem" }}>
              <Li>Предоставить работающий промокод в течение 15 минут после подтверждения оплаты.</Li>
              <Li>Обеспечивать доступность сервиса не менее 95% времени в месяц.</Li>
              <Li>Хранить данные о транзакциях в соответствии с требованиями законодательства.</Li>
            </ul>
            <br/>
            <p><strong style={{color:"#fff"}}>Пользователь обязуется:</strong></p>
            <ul style={{ padding: 0, marginTop: "0.5rem" }}>
              <Li>Использовать промокод исключительно в личных некоммерческих целях.</Li>
              <Li>Не передавать и не продавать промокод третьим лицам.</Li>
              <Li>Соблюдать Пользовательское соглашение сервиса.</Li>
            </ul>
          </Section>

          <Section title="6. Срок действия промокода">
            <ul style={{ padding: 0 }}>
              <Li>Промокод действует <strong style={{color:"#fff"}}>12 месяцев</strong> с момента покупки.</Li>
              <Li>По истечении срока действия неиспользованные сессии аннулируются без возврата средств.</Li>
              <Li>Промокод считается использованным при создании игровой комнаты, независимо от того, была ли проведена игра.</Li>
            </ul>
          </Section>

          <Section title="7. Возврат денежных средств">
            <ul style={{ padding: 0 }}>
              <Li>Пользователь вправе отказаться от услуг и получить возврат в течение <strong style={{color:"#fff"}}>14 календарных дней</strong> с момента оплаты.</Li>
              <Li>Возврат осуществляется за вычетом фактически использованных сессий по цене: стоимость тарифа / количество сессий × использованные сессии.</Li>
              <Li>Для возврата направьте запрос на <strong style={{color:"#ff3cac"}}>{EMAIL}</strong> с указанием email оплаты и номера заказа.</Li>
              <Li>Возврат производится тем же способом, которым была произведена оплата, в течение 10 рабочих дней.</Li>
            </ul>
          </Section>

          <Section title="8. Ограничение ответственности">
            <p>Исполнитель не несёт ответственности за:</p>
            <ul style={{ padding: 0, marginTop: "0.5rem" }}>
              <Li>Временную недоступность сервиса по техническим причинам.</Li>
              <Li>Потерю промокода пользователем (промокод дублируется на email).</Li>
              <Li>Качество интернет-соединения на стороне Пользователя.</Li>
            </ul>
            <br/>
            <p>Максимальная ответственность Исполнителя ограничена суммой оплаченного Пользователем тарифа.</p>
          </Section>

          <Section title="9. Персональные данные">
            <p>При оформлении заказа Пользователь предоставляет email-адрес для получения промокода. Обработка осуществляется в соответствии с <a href="/privacy" style={{color:"#00f5ff"}}>Политикой конфиденциальности</a>.</p>
          </Section>

          <Section title="10. Изменение условий">
            <p>Исполнитель вправе изменять условия Оферты. Новая редакция вступает в силу с момента публикации. К ранее оплаченным заказам применяются условия, действовавшие на момент оплаты.</p>
          </Section>

          <Section title="11. Реквизиты исполнителя">
            <p>
              <strong style={{color:"#fff"}}>{OPERATOR}</strong><br/>
              ИНН: {INN}<br/>
              ОГРНИП: {OGRNIP}<br/>
              Контактный email: <strong style={{color:"#ff3cac"}}>{EMAIL}</strong><br/>
              Сайт: {SITE}
            </p>
          </Section>

          {/* Footer */}
          <div style={{
            marginTop: "2rem", padding: "1rem 1.25rem",
            background: "#0d0820", border: "2px solid #000",
            borderRadius: "0.75rem", boxShadow: "2px 2px 0 #000",
            fontFamily: "'Nunito', sans-serif", fontSize: "0.78rem", color: "#444",
            textAlign: "center",
          }}>
            {OPERATOR} · ИНН {INN} · ОГРНИП {OGRNIP}<br/>
            Оферта соответствует требованиям ст. 437 ГК РФ.
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "2rem", display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => navigate("/terms")} className="btn-cartoon btn-secondary" style={{ padding: "0.6rem 1.5rem" }}>
            📄 Пользовательское соглашение
          </button>
          <button onClick={() => navigate("/")} className="btn-cartoon btn-primary" style={{ padding: "0.6rem 1.5rem" }}>
            🎮 На главную
          </button>
        </div>

      </div>
    </div>
  );
}